<template>
  <div>
    <BaseHeader class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col>
          <p class="h2 text-white d-inline-block mb-0">
            Établissements scolaires
          </p>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </BaseHeader>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12">
          <SchoolEstablishmentForm
            :on-success="save"
            title="Créer un établissement"
            redirect="/establishments/schools/index"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { RouteBreadcrumb, BaseHeader } from '@coop-zone/coop-zone-argon'
import SchoolEstablishmentForm from '@/components/SchoolEstablishments/SchoolEstablishmentForm'

export default {
  components: {
    SchoolEstablishmentForm,
    RouteBreadcrumb,
    BaseHeader,
  },
  created() {
    this.$store.commit('schoolEstablishments/SET_SCHOOL_ESTABLISHMENT', {})
  },
  methods: {
    async save() {
      await this.$store.dispatch(
        'schoolEstablishments/createSchoolEstablishment'
      )
    },
  },
}
</script>
